import { onMounted, onUnmounted } from "vue";

/**
 * Composable for managing session timer with customizable timeout and callback.
 *
 * @param {number} timeoutMs - Timeout duration in milliseconds
 * @param {Function} onTimeout - Callback function to execute when timeout is reached
 */
export function useSessionTimer(timeoutMs, onTimeout) {
    let timer = null;

    const startTimer = () => {
        // Clear any existing timer
        if (timer) {
            clearTimeout(timer);
        }

        // Set timer to execute callback after timeout
        timer = setTimeout(() => {
            if (onTimeout && typeof onTimeout === "function") {
                onTimeout();
            }
        }, timeoutMs);
    };

    const stopTimer = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };

    // Start timer immediately on mount
    onMounted(() => {
        startTimer();
    });

    // Cleanup on unmount
    onUnmounted(() => {
        stopTimer();
    });

    return {
        startTimer,
        stopTimer,
    };
}
